module.exports = __webpack_public_path__ + "img/multiTank_new.21e0e642.jpg";